export default {
  1: "Школа №1",
  2: "Школа №2",
  3: "Гимназия им. С.В. Ковалевской"
};
